<div class="padding">
  <form [formGroup]="lienDetails">
    <app-term [uiConfiguration]="uiConfiguration.lienDetailsConfiguration!" [errors$]="observableErrors$" [order]="order" [isDisabled]="isDisabled"></app-term>

    @if (uiConfiguration.lienDetailsConfiguration?.showAmount) {
      <div class="flex-container">
        <div class="validated-form-field-container flex-container">
          <mat-form-field class="flex-item form-field" appearance="outline">
            <mat-label>{{ 'common.labels.amount' | transloco }}</mat-label>
            <input matInput data-testid="amount-field" [placeholder]="'common.labels.amount' | transloco" formControlName="amount" type="number">
          </mat-form-field>
          <lib-error-bubble [control]="lienDetails.controls['amount']"
          [message]="amountError$"></lib-error-bubble>
        </div>
      </div>
    }

    @if (uiConfiguration.lienDetailsConfiguration?.showTrustIndenture ||
      uiConfiguration.lienDetailsConfiguration?.showStillHavePossession) {
      <div class="flex-container flex-item padding-top">
        @if (uiConfiguration.lienDetailsConfiguration?.showTrustIndenture) {
          <div class="validated-form-field-container flex-container">
            <mat-checkbox class="flex-item" formControlName="trustIndenture" [disabled]="isDisabled"
              data-testid="trust-indenture-checkbox">
              {{ 'orders.trustIndenture' | transloco }}
            </mat-checkbox>
            <lib-error-bubble [control]="lienDetails.controls['trustIndenture']"
            [message]="trustIndentureError$"></lib-error-bubble>
          </div>
        }
        @if (uiConfiguration.lienDetailsConfiguration?.showStillHavePossession) {
          <div class="validated-form-field-container flex-container">
            <mat-checkbox class="flex-item" formControlName="stillHavePossession" [disabled]="isDisabled"
              data-testid="possession-checkbox">
              {{ 'orders.stillHavePossession' | transloco }}
            </mat-checkbox>
          </div>
        }
      </div>
    }

    @if (uiConfiguration.lienDetailsConfiguration?.showVehicleReleasedDate) {
      <div class="flex-container">
        <div class="validated-form-field-container flex-container">
          <mat-form-field class="form-field flex-item" appearance="outline">
            <mat-label>{{ 'orders.vehicleReleasedDate' | transloco }}</mat-label>
            <input matInput [matDatepicker]="vehicleReleasedDate" formControlName="vehicleReleasedDate"
              data-testid="vehicle-released-date-field" [placeholder]="'common.labels.yyyyMmDd' | transloco">
            <mat-datepicker-toggle matSuffix [for]="vehicleReleasedDate"></mat-datepicker-toggle>
            <mat-datepicker #vehicleReleasedDate></mat-datepicker>
          </mat-form-field>
          <lib-error-bubble [control]="lienDetails.get('vehicleReleasedDate')!" [message]="vehicleReleasedDateError$"></lib-error-bubble>
        </div>
      </div>
    }

    @if (uiConfiguration.lienDetailsConfiguration?.showWorkLastCompletedDate) {
      <div class="flex-container">
        <div class="validated-form-field-container flex-container">
          <mat-form-field class="form-field flex-item" appearance="outline">
            <mat-label>{{ 'orders.workLastCompletedDate' | transloco }}</mat-label>
            <input matInput [matDatepicker]="workLastCompletedDate" formControlName="workLastCompletedDate"
              data-testid="work-last-completed-date-field" [placeholder]="'common.labels.yyyyMmDd' | transloco">
            <mat-datepicker-toggle matSuffix [for]="workLastCompletedDate"></mat-datepicker-toggle>
            <mat-datepicker #workLastCompletedDate></mat-datepicker>
          </mat-form-field>
          <lib-error-bubble [control]="lienDetails.get('workLastCompletedDate')!" [message]="workLastCompletedDateError$"></lib-error-bubble>
        </div>
      </div>
    }

    @if (uiConfiguration.lienDetailsConfiguration?.showProvidedPartsOrAccessories) {
      <div class="validated-form-field-container flex-container">
        <mat-checkbox class="flex-item" formControlName="providedPartsOrAccessories" [disabled]="isDisabled"
          data-testid="provided-parts-or-accessories-checkbox">
          {{ 'orders.providedPartsOrAccessories' | transloco }}
        </mat-checkbox>
      </div>
    }

    @if (uiConfiguration.lienDetailsConfiguration?.showPartsProvidedDate) {
      <div class="flex-container">
        <div class="validated-form-field-container flex-container">
          <mat-form-field class="form-field flex-item" appearance="outline">
            <mat-label>{{ 'orders.partsProvidedDate' | transloco }}</mat-label>
            <input matInput [matDatepicker]="partsProvidedDate" formControlName="partsProvidedDate"
              data-testid="parts-provided-date-field" [placeholder]="'common.labels.yyyyMmDd' | transloco">
            <mat-datepicker-toggle matSuffix [for]="partsProvidedDate"></mat-datepicker-toggle>
            <mat-datepicker #partsProvidedDate></mat-datepicker>
          </mat-form-field>
          <lib-error-bubble [control]="lienDetails.get('partsProvidedDate')!" [message]="partsProvidedDateError$"></lib-error-bubble>
        </div>
      </div>
    }

    @if (uiConfiguration.lienDetailsConfiguration?.showAdditionalInformation) {
      <div class="flex-container">
        <div class="validated-form-field-container flex-container">
          <mat-form-field class="flex-item form-field" appearance="outline">
            <mat-label>{{ 'orders.additionalInformation' | transloco }}</mat-label>
            <textarea matInput data-testid="additional-information-field" formControlName="additionalInformation"
            [placeholder]="'orders.additionalInformation2' | transloco"></textarea>
          </mat-form-field>
          <lib-error-bubble [control]="lienDetails.controls['additionalInformation']"
          [message]="additionalInformationError$"></lib-error-bubble>
        </div>
      </div>
    }

    @if (uiConfiguration.lienDetailsConfiguration?.showCourtOrder) {
      <div class="flex-container">
        <div class="validated-form-field-container flex-container">
          <mat-form-field class="flex-item form-field" appearance="outline">
            <mat-label>{{ 'orders.courtOrder' | transloco }}</mat-label>
            <textarea matInput data-testid="court-order-field" formControlName="courtOrder"
            [placeholder]="'orders.courtOrder' | transloco"></textarea>
          </mat-form-field>
          <lib-error-bubble [control]="lienDetails.controls['courtOrder']"
          [message]="courtOrderError$"></lib-error-bubble>
        </div>
      </div>
    }

    @if (uiConfiguration.lienDetailsConfiguration?.showOtherChanges) {
      <div class="flex-container">
        <div class="validated-form-field-container flex-container">
          <mat-form-field class="flex-item form-field" appearance="outline">
            <mat-label>{{ 'orders.otherChanges' | transloco }}</mat-label>
            <textarea matInput data-testid="other-changes-field" formControlName="otherChanges"
            [placeholder]="'orders.otherChanges' | transloco"></textarea>
          </mat-form-field>
          <lib-error-bubble [control]="lienDetails.controls['otherChanges']"
          [message]="otherChangesError$"></lib-error-bubble>
        </div>
      </div>
    }
  </form>
</div>